import { render } from "./TreeItem.vue?vue&type=template&id=55a1c81c&scoped=true"
import script from "./TreeItem.vue?vue&type=script&lang=ts"
export * from "./TreeItem.vue?vue&type=script&lang=ts"

import "./TreeItem.vue?vue&type=style&index=0&id=55a1c81c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-55a1c81c"

export default script